import { Stack, Typography } from '@mui/material';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { SuspenseWithSentryErrorBoundary } from '@retail/components';
import { ConditionLevelSelectContainer } from '../../../ConditionActionsBase';

interface Props {
  supplierNumber?: number;
  assortmentName: string;
}

export function LevelStep({ supplierNumber, assortmentName }: Props) {
  const t = useCalculusTFunction();

  if (!supplierNumber) {
    return (
      <Stack gap={1}>
        <Typography variant="body1">
          {t('calculus.createAllConditions.assortmentLevelInfo')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {assortmentName}
        </Typography>
      </Stack>
    );
  }

  return (
    <SuspenseWithSentryErrorBoundary>
      <ConditionLevelSelectContainer supplierNumber={supplierNumber}>
        {() => null}
      </ConditionLevelSelectContainer>
    </SuspenseWithSentryErrorBoundary>
  );
}
